import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import MarketingCostsAPI from '../../api/marketingCosts';

export const state = {
  records: [],
  suggestions: { campaigns: [], sources: [], mediums: [] },
  summary: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchingSuggestions: false,
    isFetchingSummary: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMarketingCosts(_state) {
    return [..._state.records].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
  },
  getSuggestions(_state) {
    return _state.suggestions;
  },
  getSummary(_state) {
    return _state.summary;
  },
};

export const actions = {
  get: async ({ commit }, params = {}) => {
    commit(types.SET_MARKETING_COST_UI_FLAG, { isFetching: true });
    try {
      const response = await MarketingCostsAPI.get(params);
      commit(types.SET_MARKETING_COSTS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_MARKETING_COST_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, costObj) => {
    commit(types.SET_MARKETING_COST_UI_FLAG, { isCreating: true });
    try {
      const response = await MarketingCostsAPI.create(costObj);
      commit(types.ADD_MARKETING_COST, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MARKETING_COST_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_MARKETING_COST_UI_FLAG, { isUpdating: true });
    try {
      const response = await MarketingCostsAPI.update(id, updateObj);
      commit(types.EDIT_MARKETING_COST, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MARKETING_COST_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_MARKETING_COST_UI_FLAG, { isDeleting: true });
    try {
      await MarketingCostsAPI.delete(id);
      commit(types.DELETE_MARKETING_COST, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MARKETING_COST_UI_FLAG, { isDeleting: false });
    }
  },
  fetchSuggestions: async ({ commit, state: s }) => {
    if (s.suggestions.campaigns.length > 0) return;
    commit(types.SET_MARKETING_COST_UI_FLAG, { isFetchingSuggestions: true });
    try {
      const response = await MarketingCostsAPI.getSuggestions();
      commit('SET_SUGGESTIONS', response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_MARKETING_COST_UI_FLAG, {
        isFetchingSuggestions: false,
      });
    }
  },
  fetchSummary: async ({ commit }, params = {}) => {
    commit(types.SET_MARKETING_COST_UI_FLAG, { isFetchingSummary: true });
    try {
      const response = await MarketingCostsAPI.getSummary(params);
      commit('SET_SUMMARY', response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_MARKETING_COST_UI_FLAG, { isFetchingSummary: false });
    }
  },
};

export const mutations = {
  [types.SET_MARKETING_COST_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.ADD_MARKETING_COST]: MutationHelpers.create,
  [types.SET_MARKETING_COSTS]: MutationHelpers.set,
  [types.EDIT_MARKETING_COST]: MutationHelpers.update,
  [types.DELETE_MARKETING_COST]: MutationHelpers.destroy,
  SET_SUGGESTIONS(_state, data) {
    _state.suggestions = data;
  },
  SET_SUMMARY(_state, data) {
    _state.summary = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
